export default (sel, base = document) => base.querySelector(sel);
